export default __webpack_public_path__ + "3360789c1050f720d1baa4e7953440c9.svg";